import { SVGProps } from 'react';
import { colors } from 'syngenta-digital-cropwise-react-ui-kit';

const IconPlanting = ({
  height = '12px',
  width = '12px',
  color = colors.neutral60,
  ...props
}: SVGProps<SVGSVGElement>) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M5.20366 2.88908C5.59608 2.63652 5.59916 2.03373 5.21054 1.54271C4.82192 1.05168 4.18876 0.858364 3.79634 1.11092C3.40392 1.36348 3.40084 1.96627 3.78946 2.45729C4.17808 2.94832 4.81123 3.14164 5.20366 2.88908Z"
      fill={color}
    />
    <path
      d="M6.36689 6.6763C6.64202 6.26948 6.47693 5.63689 5.99816 5.26338C5.51939 4.88987 4.90823 4.91688 4.63311 5.3237C4.35798 5.73052 4.52307 6.36311 5.00184 6.73662C5.48061 7.11013 6.09177 7.08312 6.36689 6.6763Z"
      fill={color}
    />
    <path
      d="M7.78946 3.54271C7.40084 4.03373 7.40392 4.63652 7.79634 4.88908C8.18877 5.14164 8.82192 4.94832 9.21054 4.45729C9.59916 3.96627 9.59608 3.36348 9.20366 3.11092C8.81124 2.85836 8.17808 3.05168 7.78946 3.54271Z"
      fill={color}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.5 6.5C0.947715 6.5 0.5 6.94772 0.5 7.5V11.5H11.5V7.5C11.5 6.94772 11.0523 6.5 10.5 6.5H9.39039C8.92737 6.5 8.57238 6.80699 8.40896 7.14521C8.18466 7.60943 7.5698 8.5 6 8.5C4.4302 8.5 3.81534 7.60943 3.59104 7.14521C3.42762 6.80699 3.07263 6.5 2.60961 6.5H1.5ZM1.5 10.5V7.5H2.60963C2.60963 7.5 2.61138 7.49999 2.61498 7.50121C2.61898 7.50256 2.62592 7.50561 2.63499 7.51203C2.65439 7.52576 2.67578 7.54953 2.69064 7.58028C3.02343 8.26901 3.9284 9.5 6 9.5C8.0716 9.5 8.97657 8.26901 9.30936 7.58028C9.32422 7.54953 9.34561 7.52576 9.36501 7.51203C9.37408 7.50561 9.38102 7.50256 9.38502 7.50121C9.38862 7.49999 9.39039 7.5 9.39039 7.5H10.5V10.5H1.5Z"
      fill={color}
    />
  </svg>
);

export default IconPlanting;
